export default __webpack_public_path__ + "static/media/level5.f2255e4b.png";